var gameConfig = "gameconf.js";
var defaultConfig = "config.js?v="+Date.now().toString();
var configPath = "/config/";
var config = getConfig(window.location.href);
var translations = "translations.js?v="+Date.now().toString();

var defaultScripts = [
    'framework/src/vendor/jquery.min.js',
    'framework/src/vendor/tween.js',
    'framework/src/vendor/jquery.lettering-0.6.1.min.js'
];

export async function load(gameset) {

    await loadConfig(config);
    await loadTranslations();

    try {
        await loadGameConfig();
    } catch (e) {
        console.log(e);
    }

    await loadDefaultScripts();
    if(gameset.scripts) {
        await loadScripts(gameset.scripts);
    }
}

async function loadConfig(config) {

        console.log("Loading config...", configPath + config);

        try {
            return await getScript(configPath + config);
        } catch (e) {
            console.warn("Loading config " + configPath + config + " failed");

            if(config != defaultConfig) {
                console.log("Loading default config...", configPath + defaultConfig, e);
                try {
                    return await getScript(configPath + defaultConfig);
                } catch (e2) {
                    console.warn("Loadinf config " + configPath + defaultConfig + " failed", e2);
                }

            }
        }

        return Promise.reject("Load config failed");
}

async function loadTranslations() {
    console.log("Loading translations...", configPath + translations);

    try {
        return await getScript(configPath + translations);
    } catch (e) {
        console.warn("Loading translations " + configPath + translations + " failed");
    }
}

async function loadGameConfig() {
    return await getScript(gameConfig);
}

async function loadDefaultScripts() {
    for(let script of defaultScripts) {
        await getScript(script);
    }
}

async function loadScripts(scripts = []) {
    for(let script of scripts) {
        if (!defaultScripts.includes(script)) {
            await getScript(script);
        }
    }
}

function getConfig(url) {
    var match = url.match(/static\.(.*)\.kajotgames/);
    return (match && match[1]) ? (match[1] + "." + defaultConfig) : defaultConfig;
}

function getScript(source) {

    return new Promise<void>((res, rej) => {

        var script = document.createElement('script');
        var prior = document.getElementsByTagName('script')[0];
        script.async = true;

        // @ts-ignore
        script.onload = script.onreadystatechange = function( _, isAbort ) {
            // @ts-ignore
            if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
                // @ts-ignore
                script.onload = script.onreadystatechange = null;
                script = undefined;

                if(!isAbort) { res(); }
            }
        };

        script.onerror = rej;

        script.src = source;
        prior.parentNode.insertBefore(script, prior);

    });
}

